import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID, NUMBER, DATETIME, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import Carrier from './Carrier'
import Account from './Account'
import Consignment from './Consignment'
import File from './File'

export default class extends Resource {
  static name = 'edi'

  static get fields () {
    return {
      id: new UUID(),
      edi_status: new NUMBER(),
      import_status: new NUMBER(),
      import_stime: new DATETIME(),
      import_etime: new DATETIME(),
      import_file_name: new STRING(),
      import_manifest_id: new NUMBER(),
      import_manifest_no: new STRING(),
      import_manifest_time: new STRING(),
      import_cons: new NUMBER(),
      import_items: new NUMBER(),
      import_weight: new NUMBER(),
      import_cube: new NUMBER(),
      import_duplicates: new NUMBER(),
      import_errors: new STRING(),
      import_notes: new STRING(),
      import_appinfo: new STRING(),
      export_status: new NUMBER(),
      export_stime: new DATETIME(),
      export_etime: new DATETIME(),
      export_file_name: new STRING(),
      export_errors: new STRING(),
      export_notes: new STRING(),
      osp_chainit_id: new NUMBER(),
      edi_type: new STRING(),
      consignments: new COLLECTION(Consignment),
      carrier: new ITEM(Carrier),
      account: new ITEM(Account),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      file: new ITEM(File),
      error_file: new ITEM(File),
      edi_id: new NUMBER()
    }
  }
}
